import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {DataService} from "../../../../../service/data.service";
import {Router} from "@angular/router";
import he from "he";
import {FooterService} from "../../../../common/footer/footer.service";

@Component({
  selector: 'app-inscription-confirmee-cours',
  templateUrl: './inscription-confirmee-cours.component.html',
  styleUrls: ['./inscription-confirmee-cours.component.scss']
})
export class InscriptionConfirmeeCoursComponent implements OnInit {
  protected selectedCours = JSON.parse(sessionStorage.getItem('selectedCours') || '{}');
  protected selectedMember = JSON.parse(sessionStorage.getItem('selectedMember') || '{}');
  protected inscriptionInfos = JSON.parse(sessionStorage.getItem('inscriptionCours') || '{}');
  protected isReservationCours = JSON.parse(sessionStorage.getItem('reservationCours') || '{}');
  protected connectedAccount = JSON.parse(localStorage.getItem('selectedCompte') || '{}');

  protected emails: string[] = [];
  protected coursName!: string;
  constructor(private sanitizer: DomSanitizer, private dataService: DataService, private router:Router, private footerService: FooterService) {
    if (this.selectedMember == null || this.selectedCours == null || this.connectedAccount == null) {
      this.router.navigateByUrl("/");
    }
  }

  async ngOnInit() {
    this.footerService.setFooterVisibility(true);
    this.coursName = he.decode(this.selectedCours.name);
    console.log("Reservation ?: " + this.isReservationCours);
    if (this.isReservationCours === false) {
      this.emails.push(this.connectedAccount.email);
      if (!this.emails.includes(this.connectedAccount.login)) {
        this.emails.push(this.connectedAccount.login)
      } else if (!this.emails.includes(this.connectedAccount.email2)) {
        this.emails.push(this.connectedAccount.email2)
      }
      await this.sendEmail();
    }
    this.destroyInscriptionObjects();
  }

  ngOnDestroy() {
    this.destroyInscriptionObjects();
  }

  sendEmail(): Promise<void> {
    console.log(this.inscriptionInfos.periode_annee);
    console.log(this.selectedCours.price);
    console.log(this.selectedCours.semesterPrice);
    console.log(this.inscriptionInfos.reduction);
    let price = this.inscriptionInfos.periode_annee === "Année" || this.inscriptionInfos.periode_annee === "Année continuée" ? Number(this.selectedCours.price) : this.selectedCours.semesterPrice;
    price -= this.inscriptionInfos.reduction;
    return new Promise<void>((resolve, reject) => {
      this.dataService
        .sendMailCoursConfirmation(
          this.selectedMember.numero_personne,
          this.selectedCours.id,
          this.emails,
          price,
          this.inscriptionInfos.periode_annee,
        )
        .subscribe(
          (response) => {
            // Handle success if needed
            resolve();
          },
          (error) => {
            // Handle error if needed
            reject(error);
          }
        );
    });
  }
  destroyInscriptionObjects() {
    sessionStorage.removeItem('selectedCours');
    sessionStorage.removeItem('selectedMember');
    sessionStorage.removeItem('inscriptionCours');
    sessionStorage.removeItem('reservationCours');
  }
  handleForm() {
    this.router.navigateByUrl("/");
  }
}
